module.exports = __webpack_public_path__ + "static/img/theme_06.da953335.png";